// extracted by mini-css-extract-plugin
export var errorsContainer = "_s8-1";
export var link = "_s8-0";